import React, { useContext, useEffect, useState } from 'react';
import { fetchJob } from '../services/fetchJob';
import { useNavigate, useParams } from 'react-router-dom';
import { DContext } from '../../context/Datacontext';
import { RiUserStarFill } from "react-icons/ri";
import { FaSortAmountUpAlt } from "react-icons/fa";
import { SiActualbudget } from "react-icons/si";
import { FaUsers } from "react-icons/fa";
import { MdOutgoingMail } from "react-icons/md";
import { FaIndustry } from "react-icons/fa";
import { FcHighPriority } from "react-icons/fc";
import { BsBuildingsFill } from "react-icons/bs";
import { BsCalendarDateFill } from "react-icons/bs";
import { GoDotFill } from "react-icons/go";
import { BsBackpack4Fill } from "react-icons/bs";
import { MdLightMode } from "react-icons/md";
import { BsPostcardFill } from "react-icons/bs";
import { IoPeopleSharp } from "react-icons/io5";
import { HiUserAdd } from "react-icons/hi";
import { FaRegEdit } from "react-icons/fa";
import { apiFetch } from '../services/fetchApi';
import { renderCapitalize } from '../../utils/renderCapitalize';

export const ViewJobs = () => {
    const { BeURL, currentUser, showAlert } = useContext(DContext);
    const navigate = useNavigate();
    const { id } = useParams();
    const [job, setJob] = useState(null)

    useEffect(() => {
        if (id && BeURL) {
            apiFetch(`${BeURL}/fetch-job/${id}`, { method: 'get' })
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        setJob(data.job)
                    }
                    else {
                        showAlert(data.message)
                    }
                })
                .catch(err => {
                    console.log("Error in fetching job:", err)
                    showAlert("Trouble in connecting to server! Try again later.")
                })
        }
    }, [BeURL, id])


    // Date Format Function (DD-MM-YYYY)
    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };


    const memberList = [
        {
            role: "Reporting Manager",
            ...job?.reportingManager
        },
        {
            role: "Reporting Team Lead",
            ...job?.reportingTeamLead
        },
        ...(job?.assignedTo || []).map(a => ({
            role: "Assigned To",
            ...a
        })),
        {
            role: "SAN SPOC",
            ...job?.primaryRecruiter
        }
    ]
    // Access control for Edit button
    const getAccess = (job) => {
        if (job.primaryRecruiter?.email === currentUser?.email) return true;
        if (job.reportingTeamLead?.email === currentUser?.email) return true;
        if (job.reportingManager?.email === currentUser?.email) return true;
        if (['admin'].includes(currentUser?.role)) return true;
        return false;
    }


    if (job === null) return <div className="text-center py-10 text-gray-500">Loading... Please wait.</div>;
    if (!job) return <div className="text-center py-10 text-gray-500">Job not found</div>;

    return (
        <div className="min-h-[80vh] px-5 md:px-16 lg:px-32 mt-6 space-y-6 mb-10">
            {/* Header Button */}
            {(getAccess(job) || (job?.primaryRecruiter?.id === currentUser?.id)) && <div className="flex justify-end">
                <button
                    onClick={() => navigate('/update-job/' + job._id)}
                    className="bg-primary-500 hover:bg-primary-600 text-white gap-1 flex items-center px-4 py-1 rounded-lg transition"
                >
                    <FaRegEdit fill='white' size={16} />Update Job
                </button>
            </div>}

            {/* Job Header Card */}
            <div className="bg-gradient-to-r from-[#ECF1FF] to-[#EED8FF] shadow-sm rounded-xl p-4 md:p-6 space-y-3">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
                    {/* Left section */}
                    <div className="flex items-center gap-3">
                        <div className="border h-20 w-20 rounded-full bg-purple-200 flex items-center justify-center font-semibold text-gray-700">
                            {job?.title?.charAt(0) ?? 'J'}
                        </div>
                        <div>
                            <p>
                                Job Code: <span className="font-semibold">{job?.internalJobId}</span>
                            </p>
                            <p>
                                Job Title: <span className="font-semibold">{job?.title}</span>
                            </p>
                            <p>
                                Company: <span className="font-semibold">{job?.company?.name ?? '-'}</span>
                            </p>
                        </div>
                    </div>

                    {/* Status */}

                </div>

                {/* Job Details */}
                <div className=" grid md:flex items-center justify-between bg-white rounded-lg p-4 border border-gray-200 shadow-sm space-y-3">

                    {/* Left Info */}
                    <div className="flex flex-wrap gap-4 text-gray-700 text-sm">
                        <span className="flex items-center gap-1 bg-gray-100 px-3 py-1 rounded-full">
                            <GoDotFill className="text-gray-500" />
                            {job?.jobType ?? "-"}
                        </span>

                        <span className="flex items-center gap-1 bg-gray-100 px-3 py-1 rounded-full">
                            <GoDotFill className="text-gray-500" />
                            {job?.mode ?? "-"}
                        </span>

                        <span className={`flex items-center gap-1 px-3 py-1 rounded-full 
                            ${job?.postOnCareerPortal === "true" || job?.postOnCareerPortal === true
                                ? "bg-green-100 text-green-700"
                                : "bg-red-100 text-red-700"
                            }`}
                        >
                            <GoDotFill />
                            {job?.postOnCareerPortal === "true" || job?.postOnCareerPortal === true
                                ? "Posted"
                                : "Not Posted"}
                        </span>

                    </div>

                    {/* Right Icons & Status */}
                    <div className="flex items-center gap-4">

                        <HiUserAdd
                            className="text-xl text-primary-500 cursor-pointer hover:scale-110 transition"
                            title="Submit Candidate"
                            onClick={() => navigate(`/list-candidates?job=${job._id}`)}
                        />

                        <IoPeopleSharp
                            className="text-xl text-primary-500 cursor-pointer hover:scale-110 transition"
                            title="Profile Action"
                            onClick={() => navigate(`/profile-action?jobId=${job._id}`)}
                        />

                        <span className={`px-3 py-1 text-sm rounded-full font-medium
                           ${job?.jobStatus === "active" ? "bg-green-100 text-green-700" :
                                job?.jobStatus === "Hold" ? "bg-yellow-100 text-yellow-700" :
                                    job?.jobStatus === "Closed" ? "bg-red-100 text-red-700" :
                                        "bg-gray-100 text-gray-700"}`}
                        >
                            {job?.jobStatus ?? "-"}
                        </span>

                    </div>
                </div>



            </div>

            {/* Info Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
                {/* Experience */}
                <InfoCard
                    icon={<RiUserStarFill />}
                    title="Experience"
                    data={[
                        { label: 'Min', value: job?.experience?.min },
                        { label: 'Max', value: job?.experience?.max },
                    ]}
                />

                {/* Salary */}
                <InfoCard
                    icon={<FaSortAmountUpAlt />}
                    title={`Salary (${job?.payRange?.currency ?? '-'})`}
                    data={[
                        { label: 'Min', value: job?.payRange?.min },
                        { label: 'Max', value: job?.payRange?.max },
                    ]}
                />

                {/* Client Budget */}
                <InfoCard
                    icon={<SiActualbudget />}
                    title={`Client Budget (${job?.maxClientBudget?.currency ?? '-'})`}
                    data={[{ label: 'Amount', value: job?.maxClientBudget?.amount }]}
                />

                {/* Vacancies */}
                <InfoCard icon={<FaUsers />} title="Vacancies" data={[{ label: '', value: job?.vacancies }]} />

                {/* noticePeriod */}
                <InfoCard icon={<MdOutgoingMail />} title="noticePeriod" data={[{ label: '', value: job?.noticePeriod }]} />

                {/* industry */}
                <InfoCard icon={<FaIndustry />} title="industry" data={[{ label: '', value: job?.industry }]} />

                {/* priority */}
                <InfoCard icon={<FcHighPriority />} title="priority" data={[{ label: '', value: job?.priority }]} />

                {/* Company */}
                <InfoCard icon={<BsBuildingsFill />} title="Company" data={[{ label: 'Name', value: job?.company?.name }]} />

                {/* ✅ Formatted Date */}
                <InfoCard
                    icon={<BsCalendarDateFill />}
                    title="Date"
                    data={[
                        { label: 'Start Date', value: formatDate(job?.startDate) },
                        { label: 'End Date', value: formatDate(job?.endDate) },
                    ]}
                />


            </div>

            {/* {Skills} */}
            <div className='w-full bg-white shadow-md rounded-2xl p-5 mt-5'>
                <h3 className="text-lg font-semibold text-gray-700 capitalize mb-3">Skills</h3>
                <div className="flex flex-wrap gap-3">
                    {job.skills && job.skills.length > 0 ? (
                        job.skills.map((skill, index) => (
                            <span
                                key={index}
                                className="bg-blue-200 text-primary-800 px-3 py-1 rounded-full text-sm"
                            >
                                {skill}
                            </span>
                        ))
                    ) : (
                        <p className="text-gray-500">No skills specified.</p>
                    )}
                </div>
            </div>

            {/* Additional Information */}
            <div className="w-full mt-6">
                <h3 className="text-lg font-semibold text-gray-700 capitalize mb-4">
                    Additional Information
                </h3>


                <div className="overflow-x-auto bg-white rounded-xl shadow-md">
                    <div className="max-h-[250px] overflow-y-auto">
                        <table className="min-w-full border-collapse">
                            <thead className="bg-secondary-700 text-secondary-400 sticky top-0 z-10">
                                <tr>
                                    <th className="border whitespace-nowrap px-3 py-2">SL No</th>
                                    <th className="border whitespace-nowrap px-3 py-2">Role</th>
                                    <th className="border whitespace-nowrap px-3 py-2">ID</th>
                                    <th className="border whitespace-nowrap px-3 py-2">Name</th>
                                    <th className="border whitespace-nowrap px-3 py-2">Email</th>
                                    <th className="border whitespace-nowrap px-3 py-2">Contact</th>
                                </tr>
                            </thead>

                            <tbody>
                                {memberList.map((person, index) => (
                                    <tr key={index}>
                                        <td className="border whitespace-nowrap px-3 py-2">{index + 1}</td>
                                        <td className="border whitespace-nowrap px-3 py-2">{person?.role ?? "-"}</td>
                                        <td className="border whitespace-nowrap px-3 py-2">{person?.id ?? "-"}</td>
                                        <td className="border whitespace-nowrap px-3 py-2">{renderCapitalize(person?.name ?? "-")}</td>
                                        <td className="border whitespace-nowrap px-3 py-2">{person?.email ?? "-"}</td>
                                        <td className="border whitespace-nowrap px-3 py-2">{person?.contact ?? "-"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Location */}
            <div className='w-full bg-white shadow-md rounded-2xl p-5 mt-5'>
                <p className="text-lg font-semibold text-gray-700 mb-2">Location</p>
                <div className="flex flex-wrap gap-2">
                    {job?.location && job.location.length > 0 ? (
                        job.location.map((loc, index) => (
                            <span
                                key={loc._id || index}
                                className="px-3  py-1 bg-blue-200 rounded-full text-sm shadow-sm "
                            >
                                <strong></strong> {loc.city || '-'}
                            </span>
                        ))
                    ) : (
                        <p className="text-gray-500">No location specified.</p>
                    )}
                </div>
            </div>


            {/* Job Description */}
            <div className='w-full bg-white shadow-md rounded-2xl p-5 mt-5'>
                <h3 className="text-lg font-semibold text-gray-700 capitalize mb-3">Job Description</h3>
                <div className="text-gray-600 whitespace-pre-line" dangerouslySetInnerHTML={{ __html: job?.description || 'No description provided.' }}></div>
                {/* <p className="text-gray-600 whitespace-pre-line">
                    {job?.description || 'No description provided.'}
                </p> */}
            </div>

        </div>
    );
};


const InfoCard = ({ icon, title, data = [] }) => {
    return (
        <div className="w-full bg-white shadow-md rounded-2xl px-3 py-2 flex flex-col items-center gap-3">
            <div className=' text-secondary-300 text-xs bg-secondary-50 rounded-full p-1'>{icon}</div>
            <h3 className="text-lg font-semibold text-primary-400 capitalize text-center">{title}</h3>
            <div className="w-full flex flex-col sm:flex-row justify-between text-center gap-3 ">
                {data.map((item, i) => (
                    <div key={i} className="flex flex-col items-center w-full">

                        {item.label && <p className="text-gray-500 text-sm">{item.label}</p>}
                        <strong className="text-gray-800 text-base">{item.value ?? '-'}</strong>
                    </div>
                ))}
            </div>
        </div>
    );
};



